// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__leK4T","paramInput":"JobSimulator_paramInput__2v0_e","input":"JobSimulator_input__1mWFt"};